import { render, staticRenderFns } from "./select-widget.vue?vue&type=template&id=3c277faf&scoped=true"
import script from "./select-widget.vue?vue&type=script&lang=js"
export * from "./select-widget.vue?vue&type=script&lang=js"
import style0 from "./select-widget.vue?vue&type=style&index=0&id=3c277faf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c277faf",
  null
  
)

export default component.exports